import { Component, OnInit, ChangeDetectionStrategy, Input, ViewEncapsulation, Optional } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { LoaderFacade } from 'libs/shared/utils/loader/src'
import { Observable, of } from 'rxjs'

@Component({
  selector: 'gb-loading-spinner',
  templateUrl: './gb-loading-spinner.component.html',
  styleUrls: ['./gb-loading-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class GbLoadingSpinnerComponent implements OnInit {
  @Input() id?: string | string[]
  @Input() label?: string
  @Input() showLoader?: Observable<boolean> = of(false)
  @Input() disableBackdrop = false
  @Input() color: 'gb-primary' | 'gb-primary-contrast' = 'gb-primary'
  @Input() diameter = 60

  isLoading$?: Observable<boolean>

  get showBackdrop(): boolean {
    if (this.disableBackdrop) return false
    return this.dialogRef && Object.keys(this.dialogRef).length !== 0
  }

  constructor(
    private loaderFacade: LoaderFacade,
    @Optional() public dialogRef: MatDialogRef<GbLoadingSpinnerComponent>,
  ) {}

  getClass(): string {
    return this.color
  }

  ngOnInit(): void {
    this.setIsLoading()
  }

  /**
   * Set isLoading$ with showLoader input if id not set
   */
  setIsLoading(): void {
    this.isLoading$ = !this.id ? this.showLoader : this.loaderFacade.getIsLoading$(this.id)
  }
}
